import { baseAPI } from "../baseApi";

export const tableObjectApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение структуры информации для типов объектов
        fetchTableObjectStructure: builder.query<any, any>({
            query: () => ({
                url: `structure?AuthToken=X&type=cards`
            })
        }),
        // запрос на получении информации об объекте
        fetchTableObjectInfo: builder.query<any, any>({
            query: ({ urlType, objectType, objectId }) => ({
                url: `${urlType}/${objectType}(${objectId})`
            })
        })
    })
})

export const {
    useFetchTableObjectInfoQuery,
    useFetchTableObjectStructureQuery
} = tableObjectApiSlice


